import React, { useEffect } from "react";
import Header from "src/Components/Header/header";

function Page(props) {
  useEffect(() => {
    // Clear any leaked modal scroll-lock from preceding pages (e.g. ASK post flow)
    if (document.body.style.overflow === "hidden") {
      document.body.style.overflow = "";
    }
    if (document.body.style.paddingRight) {
      document.body.style.paddingRight = "";
    }
    if (document.body.classList.contains("modal-open")) {
      document.body.classList.remove("modal-open");
    }
  }, [props.page]);

  return (
    <div
      style={{
        backgroundColor: "#F3F2F0",
        height: "100%",
        overflow: "scroll",
        scrollbarWidth: "none",
      }}
    >
      <Header {...props} />
      <div
        style={{
          marginTop: "74px",
          paddingBottom: "20px",
        }}
      >
        {props.children}
      </div>
    </div>
  );
}

export default Page;

export const PageEnum = {
  Home: "Home",
  Profile: "Profile",
  Moderator: "Moderator",
  Settings: "Settings",
  Notifications: "Notification",
};
